import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';

import * as fromUI from './+state/ui.reducer';

export function provideUI(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(fromUI.UI_FEATURE_KEY, fromUI.uiReducer)]);
}
